import React from 'react';
import { fadeIn } from '../../utils/motion.js';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const TimelineItem = ({ experience, onClick, isActive }) => {
  const { t } = useTranslation();
  const itemVariant = fadeIn('up', 'spring', 0, 0.1);

  return (
    <motion.div
      variants={itemVariant}
      className={`relative pl-10 pr-4 md:pl-16 py-12 w-full transition-all duration-300
            ease-in-out md:cursor-pointer ${isActive ? 'md:py-14' : 'md:py-8'}`}
      onClick={onClick}
    >
      <div
        className={`absolute left-4 md:left-6 top-1/2 transform -translate-x-1/2
                -translate-y-1/2 w-4 h-4 md:w-5 md:h-5
                rounded-full border-2 border-white transition-all duration-300 bg-tertiary scale-100
                ${isActive ? 'md:bg-quaternary md:scale-125' : ''}`}
      ></div>
      <h3
        className={`font-bold transition-all duration-300 ease-in-out
                text-base text-white
                ${
                  isActive
                    ? 'md:text-white md:text-lg lg:text-xl'
                    : 'md:text-base lg:text-lg md:text-slate-400 md:hover:text-slate-200'
                }`}
      >
        {t(experience.company_name)}
      </h3>
      <p
        className={`mt-1 text-sm transition-colors duration-300 ease-in-out
                text-slate-400
                ${isActive ? 'md:text-secondary' : 'md:text-slate-500'}`}
      >
        {t(experience.date)}
      </p>
    </motion.div>
  );
};

export default TimelineItem;
